import * as React from 'react'
import { useIndustryResources } from './IndustryResourcesProvider'
import { Form } from '../../../lib/ui/form'
import SearchDropdown from './SearchDropdown'
import { useTranslation } from '../../../hooks/useTranslation'
import { PrimaryButton } from './buttons'
import { useIsDesktop, useIsMobile } from '../../../hooks/useMediaQuery'
import SearchInput from '~/components/shared/SearchInput'
import MagnifyingGlassIcon from '~/components/job_search/JobSearchPage/MagnifyingGlassIcon'
import { Button } from '../../../lib/ui/button'

export default function ToolBar() {
  const { form, onSubmit, hasFilters, resetFilters } = useIndustryResources()
  const { t } = useTranslation('ToolBar')
  const isMobile = useIsMobile()

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex max-w-[1375px] flex-col">
          <h1 className="!mb-4 font-gothamRegular text-[#333]">
            <span className="font-normal">{t('find')}</span>
            {t('industry_resources')}
          </h1>
          <p className="mb-4">{t('description')}</p>

          <div
            className={`mb-6 flex ${
              isMobile
                ? 'flex-col gap-4'
                : 'flex-row justify-between gap-3 align-text-bottom'
            }`}
          >
            <div className="w-full">
              <FilterDropdownCategory />
            </div>
            <div className="w-full">
              <FilterDropdownIndustry />
            </div>
            <div className="w-full">
              <SearchInputKeywords />
            </div>

            {!isMobile && <DesktopSearchButton />}
            {isMobile && (
              <>
                <div className="w-full">
                  <MobileSearchButton />
                </div>
                {!!hasFilters && (
                  <div className="flex w-full items-center justify-center">
                    <Button
                      size="sm"
                      type="button"
                      variant="link"
                      className="text-xs"
                      onClick={async () => {
                        await resetFilters()
                        onSubmit()
                      }}
                    >
                      {t('reset_filters')}
                    </Button>
                  </div>
                )}
              </>
            )}
            {!isMobile && (
              <div className="pt-11">
                {!!hasFilters && (
                  <Button
                    size="sm"
                    type="button"
                    variant="link"
                    className="text-xs"
                    onClick={async () => {
                      await resetFilters()
                      onSubmit()
                    }}
                  >
                    {t('reset_filters')}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </form>
    </Form>
  )
}

function FilterDropdownCategory() {
  const { t } = useTranslation('SearchDropdownCategory')
  const { form } = useIndustryResources()
  const options = t('options', { returnObjects: true })

  const transformedOptions = Object.entries(options).map(([label, value]) => ({
    label,
    value,
  }))

  return (
    <SearchDropdown
      control={form.control}
      name="type"
      label={t('label')}
      showLabel={true}
      placeholder={t('placeholder')}
      options={transformedOptions}
    ></SearchDropdown>
  )
}

function FilterDropdownIndustry() {
  const { t } = useTranslation('SearchDropdownIndustry')
  const { form } = useIndustryResources()
  const options = t('options', { returnObjects: true })

  const transformedOptions = Object.entries(options).map(([label, value]) => ({
    label,
    value,
  }))

  return (
    <SearchDropdown
      control={form.control}
      name="industry"
      label={t('label')}
      showLabel={true}
      placeholder={t('placeholder')}
      options={transformedOptions}
    ></SearchDropdown>
  )
}

function SearchInputKeywords() {
  const { t } = useTranslation('SearchInputKeywords')
  const { form } = useIndustryResources()

  return (
    <SearchInput
      control={form.control}
      name="keywords"
      label={t('label')}
      placeholder={t('placeholder')}
      icon={MagnifyingGlassIcon}
    />
  )
}
function DesktopSearchButton() {
  const isDesktop = useIsDesktop()
  const { t } = useTranslation('DesktopSearchButton')

  if (!isDesktop) return null

  return (
    <div className="w-full pt-8">
      <PrimaryButton>{t('search')}</PrimaryButton>
    </div>
  )
}

function MobileSearchButton() {
  const isDesktop = useIsDesktop()
  const { t } = useTranslation('MobileSearchButton')

  if (isDesktop) return null

  return (
    <div className="w-full pt-2">
      <PrimaryButton>{t('search')}</PrimaryButton>
    </div>
  )
}
